<template>
  <div class="VideoThumb" @click="dialog.showVideo()" role="button" v-if="content.video">
    <MuxVideoThumbnail
      :video="content.video"
      animated
      :params="{ height: 128, start: content.previewStartTime ?? 10 }"
      class="image"
    />
    <div class="buttonContainer">
      <img :src="playButtonText.src" class="playButton"/>
    </div>
  </div>
  <VideoDialog ref="dialog" :content="content" />
</template>

<script setup>
import { ref } from "vue"

import playButtonText from "~/assets/ui/play-button-text.svg"

import MuxVideoThumbnail from "../../elems/MuxVideoThumbnail.vue"
import VideoDialog from "./VideoDialog.vue"

const { content } = defineProps({ content: Object })
const dialog = ref(null)
</script>

<style scoped>

.VideoThumb {
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  height: 4.5rem;
  aspect-ratio: 8 / 3;
}

.image {
  width: 65%;
  height: 100%;
  object-fit: cover;
}

.buttonContainer {
  width: 35%;
  background-color: var(--bg-color-dark-blue);
  display: flex;
  align-items: center;
  justify-content: center;
}

.playButton {
  height: 55%;
}

@media (--screen-md) {
  .VideoThumb {
    height: 6rem;
  }
}

@media (--screen-lg) {
  .VideoThumb {
    height: 8rem;
  }
}
</style>
